import {
  EDIT_PROFILE_REQUEST,
  EDIT_PROFILE_SUCCESS,
  EDIT_PROFILE_FAILURE,
  GET_PROFILE_REQUEST,
  GET_PROFILE_SUCCESS,
  GET_PROFILE_FAILURE,
  GET_AVATAR_FAILURE,
  GET_AVATAR_SUCCESS,
  GET_AVATAR_REQUEST
} from "../../constants/constants.js";

const initialState = {
  message: "",
  error: null,
  edituserData:{},
  getuserData :{},
  getavatarData:{}
};

const ProfileReducer = (state = initialState, action) => {

  
  switch (action.type) {
    case EDIT_PROFILE_REQUEST:
      return {
        ...state,
      };
    case EDIT_PROFILE_SUCCESS:
      return {
        ...state,
        edituserData: action?.payload?.data?.user[0],
        message: action?.payload?.message,
        error: null,
      };
    case EDIT_PROFILE_FAILURE:
      return {
        ...state,
        message: action?.payload?.message,
        error: action.payload,
      };
    case GET_PROFILE_REQUEST:
      return {
        ...state,
      };
    case GET_PROFILE_SUCCESS:
      return {
        ...state,
        getuserData: action?.payload,
        message: action?.payload?.message,
        error: null,
      };
    case GET_PROFILE_FAILURE:
      return {
        ...state,
        message: action?.payload?.message,
        error: action.payload,
      };

      case GET_AVATAR_REQUEST:
      return {
        ...state,
      };
    case GET_AVATAR_SUCCESS:
      return {
        ...state,
        getavatarData: action?.payload,
        message: action?.payload?.message,
        error: null,
      };
    case GET_AVATAR_FAILURE:
      return {
        ...state,
        message: action?.payload?.message,
        error: action.payload,
      };

    default:
      return state;
  }
};

export default ProfileReducer;
